import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const m = ({
  title: o,
  titleId: l,
  ...i
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...i,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M781.282 242.982v9.835c0 14.336-10.347 26.453-24.512 28.779-25.515 4.181-50.389 14.912-74.624 32.192-32 22.805-48 50.667-48 83.648 0 19.157 7.659 28.715 22.997 28.715 3.435 0 10.325-1.344 20.672-4.011 10.709-2.304 19.349-3.456 25.856-3.456 22.229 0 42.347 8.832 60.352 26.453 18.027 17.621 27.029 40.811 27.029 69.547 0 29.12-9.557 54.101-28.757 74.987-19.157 20.907-45.397 31.339-78.72 31.339-39.872 0-72.064-15.019-96.555-45.12-24.533-30.08-36.8-71.936-36.8-125.589 0-73.941 22.507-131.904 67.541-173.867 36.821-34.304 79.957-55.232 129.429-62.763 17.856-2.709 34.091 11.243 34.091 29.312zm-315.563 0v9.685c0 14.379-10.411 26.603-24.619 28.8-26.795 4.117-52.117 15.083-75.968 32.896-31.04 23.211-46.549 50.88-46.549 83.072 0 19.157 7.68 28.715 22.997 28.715 3.456 0 10.347-1.344 20.672-4.011 10.731-2.304 19.371-3.456 25.877-3.456 21.077 0 40.896 8.555 59.477 25.6 18.603 17.024 27.883 40.512 27.883 70.4 0 29.12-9.557 54.101-28.736 74.987-19.157 20.907-45.419 31.339-78.741 31.339-39.851 0-72.043-15.019-96.555-45.12-24.533-30.08-36.8-71.936-36.8-125.589 0-73.941 22.528-131.904 67.541-173.867 36.821-34.304 79.957-55.232 129.451-62.763 17.856-2.709 34.069 11.243 34.069 29.312z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), t = r(m);
export {
  t as default
};
